import { useMemo } from "react";

import {
  selectInsuredTabAdditionalInterests,
  useEndorsementSelector,
} from "@redux/slices/endorsement";
import { usePolicyDetails } from "@routing/routes/Policies/PolicyDetails/PolicyDetailsContext";
import { isCreditCardExpired } from "@routing/routes/Policies/PolicyDetails/PolicyDetailsContent/ContentTabs/Payment/utils";

/**
 * Resolves the endorsement checkout's payment methods: the mortgage-bill billing
 * additional interest when the policy has one, otherwise the default saved card
 * and/or bank account.
 */
export function usePaymentMethods() {
  const { policy } = usePolicyDetails() ?? {};

  const additionalInterests = useEndorsementSelector(
    selectInsuredTabAdditionalInterests
  );

  const billingInterest = useMemo(
    () => additionalInterests?.find((interest) => interest.isBilling) ?? null,
    [additionalInterests]
  );

  const defaultCard = useMemo(() => {
    const cards = policy?.paymentMethods?.creditCardPaymentMethods ?? [];

    return cards.find((card) => card.default) ?? null;
  }, [policy?.paymentMethods]);

  const defaultAch = useMemo(() => {
    const accounts = policy?.paymentMethods?.achPaymentMethods ?? [];

    return accounts.find((account) => account.default) ?? null;
  }, [policy?.paymentMethods]);

  const isDefaultCardExpired = useMemo(
    () => !!defaultCard && isCreditCardExpired(defaultCard),
    [defaultCard]
  );

  return {
    billingInterest,
    defaultCard,
    defaultAch,
    isDefaultCardExpired,
  };
}
